import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AgreementReceipt from '../../../agreementReceipt.jsx';
import RespondToAgreementSent from '../respondToAgreementSent.jsx';
import ConfirmIdentity from '../confirmIdentity.jsx';
import {
    acceptAgreement,
    rejectAgreement,
} from '../../agreement/agreementActions.js';
import Page from '../../../page.jsx';
import agreementPropTypes from '../../../agreementPropTypes.js';
import partnerPropTypes from '../../../partnerPropTypes.js';
import userPropTypes from '../../../userPropTypes.js';
import SmallError from '../../../errors/smallError.jsx';

class HandleAgreementSuggestionDetails extends PureComponent {
    renderContent() {
        const {
            agreement,
            handleClickAccept,
            handleClickReject,
            partner,
            user,
        } = this.props;

        if (user.verificationStatus === 'UNKNOWN') {
            return (
                <div className="centerify r-mtl r-phl">
                    <SmallError>
                        Godkjenning av avtale er ikke mulig akkurat nå. Prøv
                        igjen senere.
                    </SmallError>
                </div>
            );
        }

        if (user.verificationStatus === 'NOT_VERIFIED') {
            return (
                <div className="centerify r-mtl r-ptl">
                    <ConfirmIdentity verificationUrl={user.verificationUrl} />
                </div>
            );
        }

        return (
            <RespondToAgreementSent
                agreement={agreement}
                handleClickAccept={handleClickAccept}
                handleClickReject={handleClickReject}
                partner={partner}
            />
        );
    }

    render() {
        const { agreement, partner } = this.props;

        return (
            <Page heading="Godkjenn avtale">
                <div>
                    <p>{partner.name} ønsker å bruke Trygg betaling.</p>

                    <div className="r-phl">
                        <AgreementReceipt
                            agreement={agreement.data}
                            partner={partner}
                            role="SELLER"
                        />
                    </div>

                    {this.renderContent()}
                </div>
            </Page>
        );
    }
}

HandleAgreementSuggestionDetails.propTypes = {
    agreement: agreementPropTypes.isRequired,
    handleClickAccept: PropTypes.func.isRequired,
    handleClickReject: PropTypes.func.isRequired,
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    partner: partnerPropTypes.isRequired,
    user: userPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement,
        itemId: state.safeTrade.itemId,
        itemType: state.safeTrade.itemType,
        partner: state.partner,
        user: state.user,
    };
}

const mapDispatchToProps = {
    handleClickAccept: acceptAgreement,
    handleClickReject: rejectAgreement,
};

function mergeProps(stateProps, dispatchProps, ownProps) {
    const { itemType, itemId, partner } = stateProps;

    return {
        ...ownProps,
        ...stateProps,
        handleClickAccept: () =>
            dispatchProps.handleClickAccept({
                itemType,
                itemId,
                partnerId: partner.id,
            }),
        handleClickReject: () =>
            dispatchProps.handleClickReject({
                itemType,
                itemId,
                partnerId: partner.id,
            }),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
    HandleAgreementSuggestionDetails
);



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/statusDetails/handleAgreementSuggestionDetails.jsx